import { render, staticRenderFns } from "./avatar-tooltip.vue?vue&type=template&id=509cd072"
import script from "./avatar-tooltip.vue?vue&type=script&lang=js"
export * from "./avatar-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports